import { Directive, OnInit } from '@angular/core';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GbgrundstueckService, GrundstueckId, GrundstueckListEntry, TimePointId } from '../../core/gb-api';
import { TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { Observable } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';

@Directive()
export abstract class AbstractGrundstueckEntryFromRoute extends AbstractComponent implements OnInit {
  public gsId: GrundstueckId;
  public timepointId: TimePointId;

  grundstueckEntry: GrundstueckListEntry;
  protected grundstueck$: Observable<GrundstueckListEntry>;

  protected constructor(
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((q) => {
      this.gsId = { id: q.get('id') };
      const timepointCtx = this.timepointService.timepointCtx;
      if (this.gsId.id) {
        this.grundstueck$ = this.grundstueckService.loadGrundstueckListEntryById(
          this.gsId.id,
          timepointCtx.timepointIso,
          timepointCtx.timepointId
        );
      } else {
        this.grundstueck$ = this.grundstueckService.loadGrundstueckListEntryByEgrid(
          this.appConfigService.einstellungHistorischeDaten,
          q.get('egrid'),
          timepointCtx.timepointIso,
          timepointCtx.timepointId
        );
      }
      this.addSub(
        this.grundstueck$.subscribe({
          next: (g) => {
            if (!this.gsId.id) {
              this.gsId = g.id;
            }
            this.grundstueckEntry = g;
            this.loadData();
          },
          error: (err) => {
            if (err.status === 404) {
              this.router.navigate(['/home/notfound']);
            }
          }
        })
      );
    });
    this.addSub(
      this.appConfigService.einstellungHistorischeDaten$.pipe(withLatestFrom(this.grundstueck$)).subscribe(() => {
        this.loadData();
      })
    );
  }

  protected abstract loadData();
}
